import image from "../../assets/pagebanner2.jpg";
import sport1 from "../../assets/sports01.jpg";
import sports1 from "../../assets/sports02.jpg";
import sport2 from "../../assets/sports03.jpg";
import sports2 from "../../assets/sports04.jpg";
import sport3 from "../../assets/sports05.jpg";
import sports3 from "../../assets/sports06.jpg";
import sport4 from "../../assets/sports08.jpg";
import sports4 from "../../assets/sports07.jpg";
import sport5 from "../../assets/sports09.jpg";
import sports5 from "../../assets/sports10.jpg";
import sport6 from "../../assets/sports11.jpg";
import sports6 from "../../assets/sports12.jpg";
import sport7 from "../../assets/sports13.jpg";
import sports7 from "../../assets/sports14.jpg";
import sport8 from "../../assets/sports15.jpg";
import sports8 from "../../assets/sports16.jpg";
import sport9 from "../../assets/sports17.jpg";
import sports9 from "../../assets/sports18.jpg";
import sport10 from "../../assets/sports19.jpg";
import sports10 from "../../assets/sports20.jpg";
import sport11 from "../../assets/sports21.jpg";
import sports11 from "../../assets/sports22.jpg";
import sport12 from "../../assets/sports23.jpg";
import sports12 from "../../assets/sports24.jpg";

export const SPORT = [
  {
    img: image,
  },
];

export const SPORTDATA = [
  {
    id: 25,
    image1: sport1,
    image2: sports1,
    title: "Gran Turismo 7",
    star: 4,
    price: "$22.49",
    newprice: " $25.33",
    quick: "Quick View",
    addto: "Add To Cart",
    news: "New",
    category: "arrival",
    mainCategory: "recommend",
  },
  {
    id: 26,
    image1: sport2,
    image2: sports2,
    title: "GRID Legends",
    star: 5,
    price: "$69.99",
    newprice: "$79.99",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
  },
  {
    id: 27,
    image1: sport3,
    image2: sports3,
    title: "Hot Wheels Unleashed",
    star: 4,
    price: "$54.79",
    newprice: "$45.36",
    quick: "Quick View",
    addto: "Add To Cart",
    news: "New",
    category: "arrival",
    mainCategory: "recommend",
  },
  {
    id: 28,
    image1: sport4,
    image2: sports4,
    title: "NBA 2K21",
    star: 5,
    price: "$16.85",
    newprice: "$19.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
  },
  {
    id: 29,
    image1: sport5,
    image2: sports5,
    title: "Need for Speed Heat",
    star: 4,
    price: "$13.14",
    newprice: "$23.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
  },
  {
    id: 30,
    image1: sport6,
    image2: sports6,
    title: "Rocket League",
    star: 4,
    price: "$17.00",
    newprice: "$20.00",
    quick: "Quick View",
    addto: "Add To Cart",
    news: "New",
    category: "arrival",
    mainCategory: "recommend",
  },
  {
    id: 31,
    image1: sport7,
    image2: sports7,
    title: "EA SPORT FIFA 22",
    star: 5,
    price: "$13.00",
    newprice: "$15.01",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
  },
  {
    id: 32,
    image1: sport8,
    image2: sports8,
    title: "Need for Speed: Unbound",
    star: 4,
    price: "$13.00",
    newprice: "$15.01",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
  },
  {
    id: 33,
    image1: sport9,
    image2: sports9,
    title: "MLB The Show 21",
    star: 4,
    price: "$16.85",
    newprice: "$19.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
  },
  {
    id: 34,
    image1: sport10,
    image2: sports10,
    title: "F1 22",
    star: 5,
    price: "$16.85",
    newprice: "$19.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
  },
  {
    id: 35,
    image1: sport11,
    image2: sports11,
    title: "PGA Tour 2K21",
    star: 4,
    price: "$15.20",
    newprice: "$22.20",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
  },
  {
    id: 36,
    image1: sport12,
    image2: sports12,
    title: "Trials Rising",
    star: 4,
    price: "$40.00",
    newprice: "$60.00",
    quick: "Quick View",
    addto: "Add To Cart",
    category: "arrival",
    news: "New",
    mainCategory: "recommend",
  },
];
